module.exports = __webpack_public_path__ + "media/src/website/images/locations/taching/taching_02-ea52c954f85e91009270f2e17858de23.jpg";